import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vehicle-expenses-list',
  templateUrl: './vehicle-expenses-list.component.html',
  styleUrls: ['./vehicle-expenses-list.component.scss']
})
export class VehicleExpensesListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
